import { ReactComponent as Loader } from '../../assets/icons/loader.svg';

function FullScreenLoader() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(249, 249, 249, 1)',
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader />
    </div>
  );
}

export default FullScreenLoader;
